import { render } from "./collection-all-page.vue?vue&type=template&id=ce213e52&scoped=true"
import script from "./collection-all-page.vue?vue&type=script&lang=js"
export * from "./collection-all-page.vue?vue&type=script&lang=js"

import "./collection-all-page.vue?vue&type=style&index=0&id=ce213e52&lang=css"
import "./collection-all-page.vue?vue&type=style&index=1&id=ce213e52&scoped=true&lang=css"
import "./collection-all-page.vue?vue&type=style&index=2&id=ce213e52&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce213e52"]])

export default __exports__